/*
 * brd-2026-featured-collection.js
 * Per-section Swiper bootstrap for the TMP featured-collection / Best Sellers strip.
 * Swiper is loaded globally by layout/theme.liquid, we just initialise it.
 */
(function () {
  'use strict';

  function whenSwiperReady(cb, attempt) {
    attempt = attempt || 0;
    if (typeof window.Swiper === 'function') return cb();
    if (attempt > 200) return;
    setTimeout(function () { whenSwiperReady(cb, attempt + 1); }, 50);
  }

  function init(root) {
    if (!root || root.dataset.brdFcInit === '1') return;

    whenSwiperReady(function () {
      var swiperEl = root.querySelector('.brd-fc-swiper');
      if (!swiperEl) return;

      var perDesktop = parseInt(root.dataset.perDesktop, 10) || 4;
      var perMobile  = parseInt(root.dataset.perMobile,  10) || 1.2;
      var showArrows = root.dataset.showArrows === 'true';
      var showDots   = root.dataset.showDots === 'true';

      var instance = new window.Swiper(swiperEl, {
        slidesPerView: perMobile,
        spaceBetween: 16,
        watchOverflow: true,
        breakpoints: {
          750: { slidesPerView: Math.max(2, perDesktop - 1), spaceBetween: 20 },
          1100: { slidesPerView: perDesktop, spaceBetween: 24 }
        },
        navigation: showArrows ? {
          nextEl: root.querySelector('.brd-featured-collection__arrow--next'),
          prevEl: root.querySelector('.brd-featured-collection__arrow--prev')
        } : false,
        pagination: showDots ? {
          el: root.querySelector('.brd-featured-collection__pagination'),
          clickable: true
        } : false,
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous products',
          nextSlideMessage: 'Next products'
        }
      });

      swiperEl.brdSwiper = instance;
      root.dataset.brdFcInit = '1';
    });
  }

  function bootAll() {
    document.querySelectorAll('.brd-featured-collection[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.brd-featured-collection[data-section-id]');
    if (s) init(s);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var s = e.target.querySelector('.brd-featured-collection[data-section-id]');
    if (!s) return;
    var swiperEl = s.querySelector('.brd-fc-swiper');
    if (swiperEl && swiperEl.brdSwiper && typeof swiperEl.brdSwiper.destroy === 'function') {
      swiperEl.brdSwiper.destroy(true, true);
      swiperEl.brdSwiper = null;
    }
  });
})();
